// C1 — the department add/edit page (its own route, no longer a panel welded
// under the list). Keys are deliberately separate from `departments.*` so the
// list screen and the form screen can be reworded independently.
module.exports = {
  ar: {
    departmentForm: {
      addTitle: 'إضافة قسم جديد',
      editTitle: 'تعديل القسم',
      crumbNew: 'قسم جديد',
      crumbEdit: 'تعديل',
      backToList: '‹ رجوع لكل الأقسام',
      loading: 'جارٍ تحميل بيانات القسم…',
      loadError: 'تعذّر تحميل القسم — يمكن يكون اتحذف. ارجع لقائمة الأقسام وجرّب تاني.',
      saving: 'جارٍ الحفظ…',
      fieldErrors: {
        nameRequired: 'اسم القسم مطلوب',
        nameTooShort: 'اسم القسم لازم حرفين على الأقل',
        nameTooLong: 'اسم القسم طويل جدًا (120 حرف كحد أقصى)',
        managerTooLong: 'اسم المدير طويل جدًا (120 حرف كحد أقصى)',
      },
      errors: {
        validation: 'في حقول محتاجة تصحيح — راجع المكتوب بالأحمر',
        forbidden: 'مش مسموح لك بالتعديل على أقسام الشركة دي',
        notFound: 'القسم مش موجود (يمكن اتحذف) — ارجع لقائمة الأقسام',
        network: 'فيه مشكلة في الشبكة — جرّب تاني',
        generic: 'تعذّر الحفظ — جرّب تاني',
      },
    },
  },
  en: {
    departmentForm: {
      addTitle: 'Add a department',
      editTitle: 'Edit department',
      crumbNew: 'New department',
      crumbEdit: 'Edit',
      backToList: '‹ Back to all departments',
      loading: 'Loading the department…',
      loadError: 'Could not load this department — it may have been deleted. Go back to the list and try again.',
      saving: 'Saving…',
      fieldErrors: {
        nameRequired: 'Department name is required',
        nameTooShort: 'The name needs at least 2 characters',
        nameTooLong: 'The name is too long (120 characters max)',
        managerTooLong: 'The manager name is too long (120 characters max)',
      },
      errors: {
        validation: 'Some fields need fixing — check the red text',
        forbidden: 'You are not allowed to change this company\u2019s departments',
        notFound: 'That department no longer exists (it may be deleted) — go back to the list',
        network: 'Network problem — please try again',
        generic: 'Could not save — please try again',
      },
    },
  },
};
